export default {
  host: `https://us-central1-devfest-bglr-19.cloudfunctions.net`,
  content: {
    organizers: [
      {
        name: 'Sayantika Banik',
        desc: 'WTM Ambassador Bangalore , Organiser GDG Bangalore',
        dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568379912/GDG%20BLR%20Organiserza/sayantika_-_GDG_Bangalore_defsfc.jpg',
        twitter: 'https://twitter.com/sayabanik',
        linkedin: 'https://www.linkedin.com/in/sayantika-banik/'
      },
      {
        name: 'Aananya',
        desc: 'WTM Ambassador Bangalore , Organiser GDG Bangalore',
        dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568379591/GDG%20BLR%20Organiserza/aananya_u7w1zt.png',
        twitter: 'https://twitter.com/py_anan',
        linkedin: 'https://www.linkedin.com/in/aananya-27/'
      },
      {
        name: 'Bhaarat Chetty',
        desc: 'Organiser GDG Bangalore',
        dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568379589/GDG%20BLR%20Organiserza/bharat_fxkazc.jpg',
        twitter: 'https://twitter.com/BharatChetty',
        linkedin: 'https://www.linkedin.com/in/bhaarat-chetty-83a27bb6/'
      },
      {
        name: 'Nikhil Jha',
        desc: 'Organiser GDG Bangalore',
        dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568379794/GDG%20BLR%20Organiserza/nikhil_hfxynj.png',
        twitter: 'https://twitter.com/nkjha007',
        linkedin: 'https://www.linkedin.com/in/nikhil-jha-98ab8979/'
      },
      {
        name: 'Dibyo Majumder',
        desc: 'Organiser GDG Bangalore',
        dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568379781/GDG%20BLR%20Organiserza/dibyo_u2pekg.png',
        twitter: 'https://twitter.com/MajumderDibyo',
        linkedin: 'https://www.linkedin.com/in/dibyo-majumder-hs23/'
      },
      {
        name: 'Runcy Oomen',
        desc: 'Organiser GCDC Bangalore',
        dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568379952/GDG%20BLR%20Organiserza/runcy_cmfm2g.jpg',
        twitter: 'https://twitter.com/runcyoommen',
        linkedin: 'https://www.linkedin.com/in/runcyoommen/'
      },
      {
        name: 'Akash Agrawal',
        desc: 'Organiser GCDC Bangalore',
        dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568379780/GDG%20BLR%20Organiserza/akahs_ub9hjf.jpg',
        twitter: 'https://twitter.com/akkiagrawal29',
        linkedin: 'https://www.linkedin.com/in/akash-agrawal-58a97813/'
      },
      {
        name: 'Narkedamilli Mounica',
        desc: 'Organiser GCDC Bangalore',
        dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568379846/GDG%20BLR%20Organiserza/mounika_ipof7q.jpg',
        twitter: 'https://twitter.com/B_as_U_like',
        linkedin: 'https://www.linkedin.com/in/narkedamillimounica/'
      }
    ],
    veterans: [
      {
        name: 'Matt Sullivan',
        designation: 'Developer relations (Flutter), Google',
        dp: 'https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562680263/matt_cepj0c.jpg',
        desc: 'Matt leads developer relations for Flutter from Google’s Mountain View campus.'
      },
      {
        name: 'Shrinath V',
        designation: 'Google Developer Expert (Product Strategy)',
        dp: 'https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562680263/shrinath_roikyl.jpg',
        desc: 'A Google Developer Expert (Product). He brings a mix of executive and entrepreneurial experience.'
      },
      {
        name: 'Amrit Sanjeev',
        designation: 'Developer Advocate, Google',
        dp: 'https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562680296/amrit_cyq8zs.jpg',
        desc: 'Amrit is a Developer Advocate at Google in the partner developer relations team and works with partners in India.'
      },
      {
        name: 'Vrushali Raut',
        designation: 'Product Engineer, GO-Jek',
        dp: 'https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562689805/vrushali_dxufaj.jpg',
        desc: 'Vrushali is a Product Engineer, Android at Gojek. She is been working in industry around 3 years.'
      },
      {
        name: 'Kishore Subramanian',
        designation: 'Software Engineer, Google',
        dp: 'https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562689802/kishore_fn9h2x.jpg',
        desc: 'Kishore has 20+ years of experience building software products as part of startups and larger companies.'
      },
      {
        name: 'Santhosh G',
        designation: 'Web developer, Walmart Labs',
        dp: 'https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562689804/santhosh_w8rhuo.jpg',
        desc: 'ADeveloper with interest in Javascript and visualization. Currently he works at Walmart Labs'
      }
    ],
    startups: [
      {
        name: 'Continual Engine',
        logo: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380299/GDG%20BLR%20Startups/continual_engine_s96vuv.svg',
        website: 'http://continualengine.com/',
        twitter: 'https://twitter.com/ContinualEngin1'
      },
      {
        name: 'Winuall',
        logo: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380300/GDG%20BLR%20Startups/winuall_jwrjck.png',
        website: 'https://www.winuall.com/',
        twitter: 'https://twitter.com/winuall'
      },
      {
        name: 'Jovian',
        logo: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380299/GDG%20BLR%20Startups/jovian_logo_ojeecp.png',
        website: 'https://www.jvn.io/',
        twitter: 'www.jvn.io'
      },
      {
        name: '23ML',
        logo: 'https://pbs.twimg.com/profile_images/1129484147490140160/BlAqIo7z_400x400.png',
        website: 'https://23ml.in/',
        twitter: 'https://twitter.com/23mlHQ'
      },
      {
        name: 'Openapp',
        logo: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380300/GDG%20BLR%20Startups/openapp_ak5rjj.svg',
        website: 'https://www.openapp.com/',
        twitter: 'https://twitter.com/openappin'
      },
      {
        name: 'Goto The Change',
        logo: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380299/GDG%20BLR%20Startups/Goto_The_Change_hil7bm.jpg',
        twitter: 'https://twitter.com/gotothechange',
        website: 'gotothechange.com'
      }
    ],
    cohorts: [
      {
        desc: 'Venue - Infosys Limited, Gate 10, Building 12, Phase I, Electronic City, Hosur Road, Bengaluru',
        locationURL: 'https://goo.gl/maps/ZfHWuRypyLRnKRxm6',
        agendaURL: 'https://drive.google.com/open?id=1pvus9RQmQqhv6S20GhMUoA7ymK40Vsc1',
        panelists: [
          {
            name: 'Kausambi manjitha',
            designation: 'CEO Kubric.io',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380106/GDG%20BLR%20Panelists/kausambi_manjitha_acdgcp.jpg',
            linkedin: 'https://www.linkedin.com/in/kmanjita/',
            twitter: 'https://twitter.com/kmanjita'
          },
          {
            name: 'Moushumi Kapoor',
            designation: 'CEO Continual Engine',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380108/GDG%20BLR%20Panelists/mousumikapoor_xox4a0.jpg',
            linkedin: 'https://www.linkedin.com/in/kapoormg/',
            twitter: 'https://twitter.com/kapoormg'
          },
          {
            name: 'Lakshya S',
            designation: 'Developer Relations India, Google',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380114/GDG%20BLR%20Panelists/lakshya_si_xgusyp.jpg',
            linkedin: 'https://www.linkedin.com/in/lakshyasi/',
            twitter: 'https://twitter.com/lakshyas90'
          },
          {
            name: 'Nikita Gandhi',
            designation: 'Project Coordinator, Google',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380109/GDG%20BLR%20Panelists/nikitagandhi_uyer3e.jpg',
            linkedin: 'https://www.linkedin.com/in/nikita-gandhi01/',
            twitter: 'https://twitter.com/Nikkitagandhi'
          },
          {
            name: 'Bhavani',
            designation: 'WTM Ambassador Chennai',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1568380106/GDG%20BLR%20Panelists/bhavaniravi_ksv5x0.jpg',
            linkedin: 'https://www.linkedin.com/in/bhavanir/',
            twitter: 'https://twitter.com/geeky_bhavani'
          }
        ],
        speakers: [
          {
            name: 'Nikita Gandhi',
            designation: 'Google',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271135/GDG%20BLR%20Speaker%20Images/nikita_gandhi_hpt17d.jpg',
            desc: 'Explore ML Program Coordinator at Google. She also loves coding in Flutter, Prior joining to Google she was an organiser for WTM Pune.',
            twitter: 'https://twitter.com/Nikkitagandhi',
            linkedin: 'https://www.linkedin.com/in/nikita-gandhi01/'
          },
          {
            name: 'Shah Dhrumil',
            designation: 'shipmnts.com',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271135/GDG%20BLR%20Speaker%20Images/0_-_Dhrumil_Shah_p5h5ak.jpg',
            desc: 'GDE for Flutter, Co-Organiser of @GDGAhmedabad , Associate Product & Customer Success Manager @shipmnts , Founder of @Flutter_Flakes',
            twitter: 'https://twitter.com/dhuma1981',
            linkedin: 'https://www.linkedin.com/in/dhuma1981/'
          },

          {
            name: 'Thiyagaraj T',
            designation: 'Kubric',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271135/GDG%20BLR%20Speaker%20Images/thiyagaraj_day_day2_zmvfcw.jpg',
            desc: 'Building frontend tech at kubric.io. I love drawing on Codepen. FOSSASIA Google Code-in Mentor 2017 & 2018, Creator of redux-knob',
            twitter: 'https://twitter.com/TheWizardJS',
            linkedin: 'https://www.linkedin.com/in/thiyagarajt/'
          },
          {
            name: 'Nikita Majumdar',
            designation: 'Senior Data Analyst, Schneider Electric',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271297/GDG%20BLR%20Speaker%20Images/CE2922A1-187A-456C-8A23-3732CB82C92A_-_nikita_majumdar_jvgjwb.jpg',
            desc: 'Obsessed with finding answers through Data',
            twitter: 'https://www.twitter.com/m_nikita4',
            linkedin: 'http://linkedin.com/in/nikita-majumdar-95459b121'
          },
          {
            name: 'Parth Jansari',
            designation: 'Freelancer, Organizer GDG Gandhinagar',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271295/GDG%20BLR%20Speaker%20Images/17850142_-_Parth_Jansari_jzrfwy.jpg',
            desc: "I'm a guy who's trying to grow up & do mature stuff but ends up gaming or designing/coding.",
            twitter: 'https://twitter.com/jansariparth',
            linkedin: 'https://www.linkedin.com/in/parth-jansari/'
          },
          {
            name: 'Mahima MS',
            designation: 'Stasis Labs',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271306/GDG%20BLR%20Speaker%20Images/mahima_-_Mahima_M.S._maz9hk.jpg',
            desc: 'Android Developer @ Stasis',
            twitter: 'https://twitter.com/mahi_amy',
            linkedin: 'https://www.linkedin.com/in/mahima-ms/'
          },
          {
            name: 'Adit Gupta',
            designation: 'ServiceNow',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271135/GDG%20BLR%20Speaker%20Images/Screen-Shot-2018-09-03-at-7.40.26-PM-253x400_-_Adit_Gupta_t4a2pz.png',
            desc: 'I’m a product designer by profession with some hands-on experience in development, entrepreneurship, and publishing research papers.',
            twitter: 'https://twitter.com/aditgupta',
            linkedin: 'https://www.linkedin.com/in/aditgupta04/'
          },

          {
            name: 'Shubham Pachori',
            designation: 'Shipmnts.com',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271135/GDG%20BLR%20Speaker%20Images/Profile_Pic_-_Shubham_Aniket_Pachori_uxh3uu.jpg',
            desc: 'Product Ninja',
            twitter: 'https://twitter.com/spachori94',
            linkedin: 'https://www.linkedin.com/in/shubham-pachori-b5703a86/'
          },

          {
            name: 'Vignesh Ramakrishnan',
            designation: 'Freshworks',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271306/GDG%20BLR%20Speaker%20Images/vignesh_pic_-_Vignesh_Ramakrishnan_dhasnv.png',
            desc: 'Senior Android Developer at Freshworks',
            twitter: 'https://twitter.com/terr_lamps',
            linkedin: 'https://www.linkedin.com/in/vignesh-ramakrishnan/'
          },
          {
            name: 'Saifur Rahman Mohsin J.',
            designation: 'Tempestronics',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271508/GDG%20BLR%20Speaker%20Images/headshot_-_CiRo_Tech_p5h6rz.jpg',
            desc: "I'm a full-time freelancer who builds web, mobile and voice-driven apps",
            twitter: 'https://twitter.com/SaifurMohsin',
            linkedin: 'https://linkedin.com/in/saifurrahmanmohsin'
          },

          {
            name: 'Rajesh Khetan',
            designation: 'GoJek',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567271299/GDG%20BLR%20Speaker%20Images/DSC_0008_-_Rajesh_Khetan_nrs3gj.jpg',
            desc: "I am working as a product engineer at Go-JEK Tech.My focus is on improving the driver application and make a driver's life easy.",
            twitter: 'https://twitter.com/khetanrajesh',
            linkedin: 'https://www.linkedin.com/in/khetanrajesh/'
          },
          {
            name: 'Krishnachytanya Ayyagari (KC)',

            designation: 'Global Programs Manager (Startup Programs), Google',

            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567441287/GDG%20BLR%20Speaker%20Images/KCAyyagari_headshot_qkhtvn.jpg',

            desc: 'Ecosystem Manager at Google and takes care of the Google Cloud startup ecosystem in India.',

            twitter: 'https://twitter.com/kc_ayyagari',

            linkedin: 'https://www.linkedin.com/in/findkc'
          },

          {
            name: 'Sathish VJ',

            designation: 'Google Developer Expert (GDE) | GCP 6x certified',

            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567441285/GDG%20BLR%20Speaker%20Images/sathishvj_vplifx.jpg',

            desc: 'Sathish is a Google Developer Expert (GDE), Google Cloud Authorized Trainer.',

            twitter: 'https://twitter.com/sathishvj',

            linkedin: 'https://www.linkedin.com/in/sathishvj'
          },

          {
            name: 'Aravind Putrevu',

            designation: 'Developer Advocate, Elastic',

            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567441497/GDG%20BLR%20Speaker%20Images/Aravind_Headshot_dgu9i9.png',

            desc: 'Developer Advocate at Elastic and looks after the Developer Relation function of India.',

            twitter: 'https://twitter.com/aravindputrevu',

            linkedin: 'https://www.linkedin.com/in/aravindputrevu'
          },

          {
            name: 'Kamesh Sampath',

            designation: 'Principal Software Engineer, Red Hat',

            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567441446/GDG%20BLR%20Speaker%20Images/kameshs_profile_512x512_ngcnds.png',

            desc: 'Kamesh is a Google Developer Expert (GDE) & Principal Software Engineer at Red Hat.',

            twitter: 'https://twitter.com/kamesh_sampath',

            linkedin: 'https://linkedin.com/in/kameshsampath'
          },

          {
            name: 'Aditya Patawari',

            designation: 'Google Developer Expert (GDE) | Founder, Devops Nexus',

            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567441917/GDG%20BLR%20Speaker%20Images/Aditya_headshot_zfkomv.jpg',

            desc: 'Aditya is a Google Developer Expert (GDE) & Founder of Devops Nexus.',

            twitter: 'https://twitter.com/adityapatawari',

            linkedin: 'https://www.linkedin.com/in/adityapatawari'
          },

          {
            name: 'Krishna Kumar',

            designation: 'CNCF Ambassador | Chief Cloud Architect, Huawei India',

            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567441943/GDG%20BLR%20Speaker%20Images/KrishnaKumar-C6-Latest_tz8e0k.jpg',

            desc: 'Krishna Kumar is CNCF Ambassador & Chief Cloud Architect Huawei India.',

            twitter: 'https://twitter.com/Krish_00',

            linkedin: 'https://www.linkedin.com/in/krishna00'
          },

          {
            name: 'Pradeep Patil',

            designation: 'Technical Lead, Bridgei2i',

            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567442024/GDG%20BLR%20Speaker%20Images/Pradeep_headshot_ymaccg.png',

            desc: 'Pradeep is a Technical Lead at Bridgei2i & certified on Google Cloud technical certifications (GCP 2x certified).',

            twitter: 'https://twitter.com/pradeeppatil21',

            linkedin: 'https://www.linkedin.com/in/pradeep-patil-5301aa49'
          },

          {
            name: 'Jayesh Bapu Ahire',

            designation: 'AI Researcher | Organizer of the Pune Elasticsearch User Group',

            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567442019/GDG%20BLR%20Speaker%20Images/jayesh_bapu_ahire_vluewd.jpg',

            desc: 'AI Researcher doing research on NTM’s and Distributed Neural Computers with renowned universities.',

            twitter: 'https://twitter.com/Jayesh_Ahire1',

            linkedin: 'https://www.linkedin.com/in/jayesh-ahire'
          }
        ]
      },
      {
        desc: 'Venue - REVA University, Yelahanka, Bengaluru',
        locationURL: 'https://goo.gl/maps/H8tC1Dn7d9jsLBng6',
        agendaURL: 'https://drive.google.com/file/d/118eGphiLUV1MqYZNgseXnyY9kaQjYHOh/view?usp=sharing',
        speakers: [
          {
            name: 'Nikhil Raichur',
            designation: 'Google',
            linkedin: 'https://www.linkedin.com/in/nikhilraichur/',
            twitter: 'https://twitter.com/nikhilraichur91',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961874/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/nikhilraichur_zgyzpm.jpg',
            desc: 'Community Manager @Google, Former Google Student Ambassador India'
          },
          {
            name: 'Ashwini Purohit',
            designation: 'CEO, Winuall',
            linkedin: 'https://www.linkedin.com/in/ashwini-purohit',
            twitter: 'https://twitter.com/ashwini0529',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961433/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/ashwini_-_Ashwini_Purohit_spkdsk.jpg',
            desc: 'Entrepreneur, Developer, Passionate about startups.'
          },
          {
            name: 'Pooja Bhaumik',
            designation: 'Bounceshare',
            linkedin: 'https://www.linkedin.com/in/poojab26/',
            twitter: 'https://twitter.com/pblead26',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961939/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/PoojaBhaumik2_-_Pooja_Bhaumik_jngno2.jpg',
            desc: 'Google Developer Expert (Flutter) & Sr. Engineer at Bounce'
          },
          {
            name: 'Thiyagaraj T',
            designation: 'Kubric',
            linkedin: 'https://www.linkedin.com/in/thiyagarajt/',
            twitter: 'https://twitter.com/TheWizardJS',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961872/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/thiyagaraj_day_day2_vn7dcx.jpg',
            desc: 'Building frontend tech at kubric.io. I love drawing on Codepen. FOSSASIA Google Code-in Mentor 2017 & 2018, Creator of redux-knob'
          },
          {
            name: 'Bhavani Ravi',
            designation: 'Oss Contributor; Wtm ambassador Chennai',
            linkedin: 'https://linkedin.com/in/bhavanir',
            twitter: 'https://twitter.com/geeky_bhavani',
            dp: 'https://res.cloudinary.com/ddbxzcb7k/image/upload/v1567964766/Screenshot_2019-09-08_at_11.15.48_PM_urjfwt.png',
            desc: 'Code, Speak, Write and Teach Tech'
          },

          {
            name: 'Vasudev Maduri',
            designation: 'Hitachi Consulting',
            linkedin: 'https://www.linkedin.com/in/vasudevmaduri/',
            twitter: 'https://twitter.com/devmaduri',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567962175/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/VASU_-_Vasudev_Maduri_y5woxp.jpg',
            desc: 'Technology Enthusiast, Machine Learning Developer'
          },
          {
            name: 'Charmi Chokshi',
            designation: 'Shipmnts.com',
            linkedin: 'https://www.linkedin.com/in/charmichokshi',
            twitter: 'https://twitter.com/CharmiChokshi',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567962102/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/cc_img_-_Charmi_Chokshi_z6ehak.jpg',
            desc: 'Machine Learning Engineer at Shipmnts.com'
          },
          {
            name: 'Lalit Rawat',
            designation: 'DXC Technology',
            linkedin: 'https://www.linkedin.com/in/lalit-rawat-53889613/',
            twitter: 'https://twitter.com/lalit01rawat',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567960863/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/Lalit_-_lalit_rawat_cjuetu.jpg',
            desc: 'Lalit Rawat is author, Blogger and trainer in various cloud technology.'
          },
          {
            name: 'Subhrajyoti Sen',
            designation: 'smallcase',
            linkedin: 'https://www.linkedin.com/in/subhrajyotisen/',
            twitter: 'https://twitter.com/iamsubhrajyoti',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961874/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/export_-_Subhrajyoti_Sen_emeoed.png',
            desc: 'Mobile Developer with a passion for Open Source'
          },

          {
            name: 'Samarth Nayyar',
            designation: 'Vellore Institute of Technology',
            linkedin: 'https://www.linkedin.com/in/samarth-nayyar-20816711b/',
            twitter: 'https://twitter.com/SamarthDesigns',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567960867/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/IMG_20181227_212644_470_-_Samarth_Nayyar_dmf51z.jpg',
            desc: 'Designer. Developer. Animator. Oh and a flower lover.'
          },
          {
            name: 'Shashank Barki',
            designation: 'Manhattan Associates',
            linkedin: 'https://www.linkedin.com/in/shashank-barki-07502aa2/',
            twitter: 'https://twitter.com/shankbarki',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567960860/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/pic1_-_shashank_barki_wgvyps.jpg',
            desc: 'Hybrid cloud implementation and Automation with expertise in GCP and AWS. Implementing machine learning and data analytics.'
          },
          {
            name: 'Shuvam Manna',
            designation: 'Developer Student Club - HIT; GDG Kolkata',
            linkedin: 'https://linkedin.com/in/shuvam-manna',
            twitter: 'https://twitter.com/shuvam360',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567960892/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/shuvam_-_Shuvam_Manna_g1noda.jpg',
            desc: 'Geek, Bookworm, Shutterbug, Hogwarts aspirant, Star Wars Nerd and a vocal detractor of Pineapple on Pizzas.'
          },
          {
            name: 'Mayur Dhurpate',
            designation: 'iMumz (https://twitter.com/imumzapp)',
            linkedin: 'https://www.linkedin.com/in/mayurdhurpate',
            twitter: 'https://twitter.com/mayurdhurpate',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567960859/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/profilepic_-_Mayur_Dhurpate_vbltky.jpg',
            desc: 'IIT BHU Alumnus. Startup Co-founder - iMumz. Web & Mobile Tech Enthusiast. Meditator - Happy and Content!'
          },
          {
            name: 'Usha Rengaraju',
            designation: 'Mysuru Consulting Group',
            linkedin: 'https://www.linkedin.com/in/usha-rengaraju-b570b7a2/',
            twitter: 'https://twitter.com/URengaraju',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961072/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/usha1_-_usha_rengaraju_koi4nz.jpg',
            desc: 'Data Scientist who is passionate about Neuroscience and Behavioral Psychology'
          },
          {
            name: 'Dibyo Majumder',
            designation: 'RNSIT Bangalore',
            linkedin: 'https://www.linkedin.com/in/dibyo-majumder-hs23/',
            twitter: 'https://twitter.com/MajumderDibyo',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961151/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/mypic_-_Dibyo_Majumder_io9sef.jpg',
            desc: 'Building for the Web 3.0'
          },
          {
            name: 'Akanshi Srivastava',
            designation: 'Slang Labs',
            linkedin: 'https://www.linkedin.com/in/akanshi32/',
            twitter: 'https://twitter.com/akanshi_s',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961302/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/squarequick_201954135427760_-_Akanshi_Srivastava_jybvue.jpg',
            desc: 'Android and UI/UX Developer'
          },

          {
            name: 'Indranil Dhanu Chandra',
            designation: 'Software Innovator @ Intel; ML Engineer @ Aditya Birla Finance Ltd.',
            linkedin: 'http://in.linkedin.com/in/indranildchandra',
            twitter: 'https://twitter.com/IndranilChandra',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961254/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/Indranil_Chandra_-_Indranil_Chandra_wxvs04.jpg',
            desc: 'Innovator | Maker | Engineer | Researcher | I teachpreach and leverage ML/DL techniques to build meaningful products.'
          },
          {
            name: 'Leena S N',
            designation: 'Co-founder/CTO/Programmer @ Good Karma',
            linkedin: 'https://www.linkedin.com/in/leenasn/',
            twitter: 'https://twitter.com/leenasn',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961261/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/Leena1_-_Leena_S_N_avchhc.jpg',
            desc:
              'A pragmatic & passionate programmer, lean thinker, eXtreme Programming evangelist, hooked into Continuous Delivery. A mother of two lovely angels.'
          },
          {
            name: 'Ranjeet Kumar',
            designation: 'Continual Engine',
            linkedin: 'https://www.linkedin.com/in/ranjeet-kumar-70513752/',
            twitter: 'https://twitter.com/ranjeetpesit',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567962349/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/IMG_20190820_135024_-_cont_engine_xekcaf.jpg',
            desc: 'A software engineer who likes to solve a real-life problemsbut is also crazy about petscooking and traveling.'
          },
          {
            name: 'Aiswarya Ramachandran',
            designation: 'Cerner Corporation',
            linkedin: 'https://www.linkedin.com/in/aiswarya-ramachandran/',
            twitter: 'https://twitter.com/aiswaryaram88',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961431/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/Aiswarya_Ramachandran_-_Aiswarya_Ramachandran_seltht.png',
            desc: 'Currently Senior Data Analyst at Cernerwith strong foundations in Machine Learning and Artificial Intelligence.'
          },
          {
            name: 'Bhuvana Kundumani',
            designation: 'Saama Technologies',
            linkedin: 'https://www.linkedin.com/in/bhuvana-kundumani-71694366/',
            twitter: 'https://twitter.com/KA_Bhuvana',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961431/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/bhuvana_-_Bhuvana_Kundumani_ovrabh.jpg',
            desc: 'Edtech entrepreneur (6 years) turned ML Researcher at forty'
          },
          {
            name: 'K.Arun Ganessh',
            designation: 'Gridraster',
            linkedin: 'https://www.linkedin.com/in/arun-ganessh-52866a10a/',
            twitter: 'https://twitter.com/karunganessh',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961874/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/WhatsApp_Image_2019-07-04_at_10.44.13_AM_-_Arun_Ganessh_kxxtjl.jpg',
            desc: 'Creative Nerd...'
          },
          {
            name: 'Aayushma Agrawal',
            designation: 'Lenskart',
            linkedin: 'https://www.linkedin.com/in/aayushma-agrawal/',
            twitter: 'https://twitter.com/AgrawalAayushma',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961494/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/WhatsApp_Image_2019-09-03_at_10.38.18_PM_-_Aayushma_Agrawal_xbb7ep.jpg',
            desc: 'Coding major time. Speaking and writing my heart out when free.'
          },
          {
            name: 'Monika Kumar Jethani',
            designation: 'PwC',
            linkedin: 'https://www.linkedin.com/in/monika-kumar-jethani-944a2259/',
            twitter: 'https://twitter.com/monika_jethani',
            dp:
              'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961494/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/Headshot_-_Monika_Jethani_bw9iw9.jpg',
            desc: 'Android developer at PwC'
          },
          {
            name: 'Rakshit Pratap Singh',
            designation: 'Continual Engine',
            linkedin: 'https://www.linkedin.com/in/rakshit-pratap-singh-4605b3163/',
            twitter: 'https://twitter.com/RakshitpratapS4',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567961456/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/cont2.png',
            desc: 'We love to code to automate things.'
          },
          {
            name: 'Pranshu Agrawal',
            designation: 'Continual Engine',
            linkedin: 'https://www.linkedin.com/in/agrawal-pranshu/',
            twitter: 'https://twitter.com/Pranshu_A',
            dp: 'https://res.cloudinary.com/ayushpriya10/image/upload/v1567962217/GDG%20BLR%20Speaker%20Images%20%28Day%202%29/pshuagrawal_a2epm0.jpg',
            desc: 'We love to code to automate things.'
          }
        ]
      }
    ]
  }
};
